import { render, staticRenderFns } from "./editMonitorSCA.vue?vue&type=template&id=9085884c&scoped=true&"
import script from "./editMonitorSCA.vue?vue&type=script&lang=js&"
export * from "./editMonitorSCA.vue?vue&type=script&lang=js&"
import style0 from "./editMonitorSCA.vue?vue&type=style&index=0&id=9085884c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9085884c",
  null
  
)

export default component.exports